const contactTypes = [
  { value: "supplies", text: "Insumos" },
  { value: "laboratory", text: "Laboratorio" },
  { value: "consultant", text: "Asesor" },
  { value: "other", text: "Otro" },
];

export default contactTypes;
